"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullURLS = exports.routeURLS = void 0;
let preRoute = "http://localhost:3000";
// Live-ish server environments
if (process.env.NODE_ENV === "production") {
    preRoute = "https://api.pixelmoments.org";
}
const routeURLS = {};
exports.routeURLS = routeURLS;
routeURLS.HEALTH = "/health";
routeURLS.AUTH = "/auth";
routeURLS.STORIES = "/stories";
routeURLS.STORIES_ADMIN = "/stories/admin";
routeURLS.STORIES_DOWNLOAD = "/stories/download";
const fullURLS = {};
exports.fullURLS = fullURLS;
for (const routeURLSKey in routeURLS) {
    if (Object.prototype.hasOwnProperty.call(routeURLS, routeURLSKey)) {
        fullURLS[routeURLSKey] = preRoute + routeURLS[routeURLSKey];
    }
}
//# sourceMappingURL=urls.js.map